module.exports = __webpack_public_path__ + "img/gift3.40aad78b.png";